import { Card, Col, Row, Tag, Skeleton } from "antd";
import EmptyState from "../../../shared/EmptyState";
import VideoPlayer from "../../../shared/VideoPlayer";

const ExistingVideoSelect = ({
  onVideoSelect,
  selectedVideoId,
  videos,
  loading,
}: {
  onVideoSelect: (video: any) => void;
  selectedVideoId: string | null;
  videos: any[];
  loading: boolean;
}) => {
  if (loading) {
    return <Skeleton active />;
  }

  const filteredVideos = videos.filter(
    (video) =>
      video.videoUri &&
      (video.status === "AVAILABLE" ||
        video.status === "AVAILABLE_WITHOUT_TRANSCRIPTION")
  );

  if (!filteredVideos.length) {
    return (
      <div className="flex items-center justify-center h-full ">
        <EmptyState />
      </div>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      {filteredVideos.map((video) => (
        <Col span={8} key={video.id}>
          <Card
            hoverable
            onClick={() => onVideoSelect(video)}
            cover={<VideoPlayer videoUri={video.videoUri} />}
            style={{
              border: video.id === selectedVideoId ? "2px solid blue" : "",
            }}
          >
            <Card.Meta
              title={video.title}
              description={<Tag color="blue">{video.tag}</Tag>}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ExistingVideoSelect;